export default __webpack_public_path__ + "static/media/7-ShareConnection.a0471676.jpeg";